import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=b04fe5d4&scoped=true&"
import script from "./Cell.vue?vue&type=script&lang=js&"
export * from "./Cell.vue?vue&type=script&lang=js&"
import style0 from "./Cell.vue?vue&type=style&index=0&id=b04fe5d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04fe5d4",
  null
  
)

export default component.exports